import React from 'react'
import { SvgIcon, SvgIconProps, useTheme } from '@mui/material'

const TwitterIcon = (props: SvgIconProps) => {
  // @ts-ignore
  const { color, fill, stroke, sx, width, height, ...otherProps } = props // eslint-disable-line
  const theme = useTheme()

  let selectedColor = color

  // @ts-ignore
  if (color && theme.palette[color]) {
    // @ts-ignore
    selectedColor = theme.palette[color].main
  }

  const fillStyle = fill || selectedColor || undefined

  const styles = {
    width: 'inherit',
    height: 'inherit',
    fill: 'inherit',
    ...sx,
  }

  const cleanedPaths = () => (
    <svg
      width={width || 48}
      height={height || 48}
      viewBox="0 0 48 48"
      fill="none"
    >
      <path
        d="M41.25 5.25H6.75C5.92031 5.25 5.25 5.92031 5.25 6.75V41.25C5.25 42.0797 5.92031 42.75 6.75 42.75H41.25C42.0797 42.75 42.75 42.0797 42.75 41.25V6.75C42.75 5.92031 42.0797 5.25 41.25 5.25ZM34.0922 18.8297C34.1062 19.05 34.1062 19.2797 34.1062 19.5047C34.1062 26.3859 28.8656 34.3125 19.2891 34.3125C16.3359 34.3125 13.5984 33.4547 11.2922 31.9781C11.7141 32.025 12.1172 32.0437 12.5484 32.0437C14.9859 32.0437 17.2266 31.2188 19.0125 29.8219C16.725 29.775 14.8031 28.275 14.1469 26.2125C14.9484 26.3297 15.6703 26.3297 16.4953 26.1188C15.3175 25.8795 14.2588 25.2398 13.4991 24.3084C12.7395 23.377 12.3257 22.2113 12.3281 21.0094V20.9437C13.0172 21.3328 13.8281 21.5719 14.6766 21.6047C13.9633 21.1293 13.3784 20.4854 12.9736 19.7298C12.5689 18.9743 12.3568 18.1306 12.3563 17.2734C12.3563 16.3031 12.6094 15.4172 13.0641 14.6484C14.3714 16.2578 16.0028 17.5741 17.8522 18.5117C19.7016 19.4493 21.7275 19.9873 23.7984 20.0906C23.0625 16.5516 25.7063 13.6875 28.8844 13.6875C30.3844 13.6875 31.7344 14.3156 32.6859 15.3281C33.8625 15.1078 34.9875 14.6672 35.9906 14.0766C35.6016 15.2812 34.7859 16.2984 33.7031 16.9406C34.7531 16.8281 35.7656 16.5375 36.7031 16.1297C35.9953 17.1703 35.1094 18.0938 34.0922 18.8297Z"
        fill={fillStyle || '#2B2E31'}
      />
    </svg>
  )

  return (
    <SvgIcon
      component={cleanedPaths}
      inheritViewBox
      sx={styles}
      {...otherProps}
    />
  )
}

export default TwitterIcon
